import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import "./index.scss"

export const InfiniteScroller = ({ children, dataLength, loadFunc, loader, endMessage, hasMore, scrollableTarget, className }) => {

    return (
        <div className='scroll-component h-100 flex-fill' >
            <InfiniteScroll
                height={300}
                dataLength={dataLength}
                next={loadFunc}
                hasMore={hasMore}
                scrollableTarget={scrollableTarget}
                loader={loader}
                className={`infinite-scroller d-flex h-100 flex-fill ${className}`}
                endMessage={endMessage}>
                {children}
            </InfiniteScroll>
        </div>
    )
}
